import { graphql } from '../../types/sx1155/gql'

export const UserHoldingsQuery = graphql(`
  query UserHoldings($filter: UserHolding_filter, $limit: Int, $skip: Int) {
    userHoldings(where: $filter, first: $limit, skip: $skip) {
      id
      balance
      user {
        id
      }
      tokenId {
        id
        assetType
        parentNFT {
          name
          symbol
          id
        }
      }
    }
  }
`)
